import { useEffect, useState } from "react";
import { Geography, SurveyComponent } from "./Components";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ThunkDispatch } from "redux-thunk";
import { AnyAction } from "redux";
import { RootState } from "store";
import { IfetchSurveyJsFormDatails } from "store/formDetailsSurveyJsFields/initialState";
import { TailSpin } from "react-loader-spinner";
import { I_InitialStateOfSurveyJS } from "store/surveyJS/initialState";
import {
  fetchSurveyJSFormDetails,
  resetSurveyJSFormDetailsAction,
} from "store/formDetailsSurveyJsFields/reducer.actions";
import { fetchDataSources } from "./Components/SurveyJs/utils/handlingOfDropDownsInHardCodeSections";
import useCustomBranding from "hooks/useCustomBranding";
import {
  resetAppliedAndReomvedProperties,
  unRegisterCustomPanels,
} from "./Components/SurveyJs";

export const EditFormDetails = () => {
  const dispatch: ThunkDispatch<any, any, AnyAction> = useDispatch();
  const { formDetails, message, stateIs } = useSelector<
    RootState,
    IfetchSurveyJsFormDatails
  >((state) => state.formSurveyJsDetails);
  const { displayView } = useSelector<RootState, I_InitialStateOfSurveyJS>(
    (state) => state.surveyJS
  );
  const { primaryColor } = useCustomBranding();
  const [dataSourcesData, setDataSourcesData] = useState<any>({
    observers: [],
    types: [],
    objects: [],
    categories: [],
    species: [],
    regions: [],
    shapes: [],
    points: [],
  });

  const { formId } = useParams();

  useEffect(() => {
    if (formId) {
      if (displayView === "survey") {
        dispatch(fetchSurveyJSFormDetails({ id: formId }));
      }
    }
  }, [formId, displayView]);

  useEffect(() => {
    return () => {
      resetAppliedAndReomvedProperties();
      // unRegisterCustomPanels();
      dispatch(resetSurveyJSFormDetailsAction());
    };
  }, []);

  useEffect(() => {
    if (stateIs === "Idle" && formDetails.programId !== undefined) {
      fetchAllDataSources(formDetails.programId, formDetails.id).then(
        (res: any) => {
          const {
            observers,
            types,
            objects,
            categories,
            species,
            regions,
            shapes,
            points,
          } = res;

          setDataSourcesData(() => {
            return {
              observers,
              types,
              objects,
              categories,
              species,
              regions,
              shapes,
              points,
            };
          });
        }
      );
    }
  }, [formDetails]);

  if (stateIs === "Pending") {
    return (
      <div className="loader min-h-[100vh] justify-center items-center flex w-full">
        <TailSpin
          height="50"
          width="50"
          color={primaryColor}
          ariaLabel="tail-spin-loading"
          radius="2"
          wrapperStyle={{}}
          wrapperClass="tailspin-loader"
          visible={true}
        />
      </div>
    );
  } else if (stateIs === "Idle") {
    return (
      <>
        <SurveyComponent
          dataSourcesData={dataSourcesData}
          formDetails={formDetails}
          doHide={displayView === "geography"}
        />
        {displayView === "geography" ? (
          <Geography dataSourcesData={dataSourcesData} />
        ) : null}
      </>
    );
  }
};

export async function fetchAllDataSources(programId: any, formId: any) {
  try {
    const [
      species,
      objects,
      observers,
      categories,
      types,
      regions,
      shapes,
      points,
    ] = await Promise.all([
      fetchDataSources("species", programId),
      fetchDataSources("objects", programId),
      fetchDataSources("observers", programId),
      fetchDataSources("categories", programId),
      fetchDataSources("types", programId),
      fetchDataSources("regions", programId),
      fetchDataSources("shapes", programId),
      fetchDataSources("points", programId),
    ]);

    return {
      observers,
      types,
      objects,
      categories,
      species,
      regions,
      shapes,
      points,
    };
  } catch (error) {
    console.error("Error fetching data:", error);
  }
}
